export function getDeviceModal(): string {
  return navigator.userAgent.substring(
    navigator.userAgent.lastIndexOf(';') + 2,
    navigator.userAgent.indexOf(')')
  );
}
